// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"753ae85b","596":"09aadc03","708":"bef1e47b","872":"22b308e6"}[chunkId] + ".chunk.js";
};